import { FormWithRedux } from '../../FormWithRedux';
import { ACCBISTOrientationCheck5Form } from './ACCBIST-OrientationCheck5Form';
import { ACCBISTRecollectionCheck5Form } from './ACCBIST-RecollectionCheck5Form';
import { ACCBISTRecollectionFailureCheck5Form } from './ACCBIST-RecollectionFailureCheck5Form';
import moment from 'moment';

import { FormValidationError } from '../../../waferJS/Form/Validation/FormValidationError';
import { FormValidation } from '../../../waferJS/Form/Validation/FormValidation';

export class ACCBISTAWPTA5Form extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('awptaCheck5Subform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    generateSubform(identifier) {
        switch(identifier) {
            case 'orientationCheck5Subform':
                return new ACCBISTOrientationCheck5Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'recollectionCheck5Subform':
                return new ACCBISTRecollectionCheck5Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'recollectionFailureCheck5Subform':
                return new ACCBISTRecollectionFailureCheck5Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        return true;
    }

    getValueType(identifier) {
        return 'date';
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        if (identifier == 'awptaCheck5DateTime') {
            let self = this;

            let timeConflict = new FormValidation('AbnormalitiesPresentConflict', function () {
                let value = self.getValue(identifier);
                let check1Value = self.getValue('awptaCheck4DateTime');
                if (value != null && value!= undefined && check1Value != null && check1Value != undefined) {
                    let firstCheck = moment(new Date(check1Value));
                    let secondCheck = moment(new Date(value));
                    var duration = moment.duration(secondCheck.diff(firstCheck));
                    var hours = duration.asHours();

                    if (hours < 1) {
                        return [new FormValidationError(FormValidationError.FormErrorType.warning, 'Current check should be at least 1 hour after the previous.')];
                    }
                    else {
                        return [];
                    }
                
                }
                else {
                    return [];
                }
            });
            return [timeConflict];
        }
        
        return [];
    }

    detailForIdentifier(prefix, value) {
        if(value.identifier == 'gcsSubform') {
            return null;
        }
        
        return super.detailForIdentifier(prefix, value);
    }

    htmlForIdentifier(prefix, value) {
        if(value.identifier == 'gcsSubform') {
            return null;
        }
        else {
            return super.htmlForIdentifier(prefix, value);
        }
    }

    shouldShowInSidebar() {
        if(this.getValue('awptaCheck4DateTime') != null && this.getValue('awptaCheck4DateTime') != undefined) {
            return true;
        }

        return false;
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-AWPTA5Form.js